<template>
    <div class="d-flex flex-row">
        <BaseInputDate
            v-model="when.date"
            v-bind="$attrs"
            v-on="$listeners"
            :label="dateLabel"
            :placeholder="datePlaceholder"
        />
        <v-spacer/>
        <BaseInputTime
            v-model="when.time"
            v-bind="$attrs"
            v-on="$listeners"
            :label="timeLabel"
            :placeholder="timePlaceholder"
        />
    </div>
</template>

<script>
import BaseInputDate from "./BaseInputDate";
import BaseInputTime from "./BaseInputTime";
import momentTimezone from "moment-timezone";
import moment from "moment";

export default {
    name: "DateTimeInput",
    components: {BaseInputDate, BaseInputTime},
    props: {
        isoDate: {
            type: String,
            validator: function (value) {
                return value === "" ? true : moment(value, moment.ISO_8601).isValid();
            }
        },
        timeZone: {
            type: String,
        },
        dateLabel: {
            type: String,
        },
        datePlaceholder: {
            type: String,
        },
        timeLabel: {
            type: String,
        },
        timePlaceholder: {
            type: String,
        }
    },
    data() {
        return {
            when: {
                date: "",
                time: "",
            },
            inputDateFormat: "YYYY-MM-DD",
            inputTimeFormat: "HH:mm",
        };
    },
    mounted() {
        this.setWhen();
    },
    computed: {
        whenDate() {
            return `${this.when.date} ${this.when.time}`;
        },
        dateTimeFormat() {
            return `${this.inputDateFormat} ${this.inputTimeFormat}`;
        },
        isoDateMoment() {
            if (this.isoDate) {
                if (this.timeZone) {
                    return this.getMomentTz(this.isoDate, moment.ISO_8601, this.timeZone);
                }

                return this.getMoment(this.isoDate, moment.ISO_8601);
            }
        },
        parsedIsoMoment() {
            if (this.isoDateMoment) {
                return {
                    date: this.isoDateMoment.format(this.inputDateFormat),
                    time: this.isoDateMoment.format(this.inputTimeFormat),
                };
            }
        },
        whenMoment() {
            if (this.when.date && this.when.time) {
                if (this.timeZone) {
                    return this.getMomentTz(this.whenDate, this.dateTimeFormat, this.timeZone);
                }

                return this.getMoment(this.whenDate, this.dateTimeFormat);
            }
        },
        whenMomentISO() {
            if (this.whenMoment) {
                return this.whenMoment.toISOString();
            }
        },
    },
    methods: {
        setWhen() {
            if (this.parsedIsoMoment && 
                this.parsedIsoMoment.hasOwnProperty('date') && 
                this.parsedIsoMoment.hasOwnProperty('time')) {

                    this.when = this.parsedIsoMoment;
            }
        },
        getMoment(date, format) {
            return moment(date, format);
        },
        getMomentTz(date, format, tz) {
            return momentTimezone.tz(date, format, tz);
        },
    },
    watch: {
        when: {
            handler() {
                if (this.whenMomentISO) {
                    this.$emit("update:isoDate", this.whenMomentISO);
                }
            },
            deep: true,
        },
        isoDate(val, oldVal) {
            if (val !== oldVal) {
                this.setWhen();
            }
        },
        timeZone() {
            if (this.timeZone && this.whenMomentISO) {
                this.$emit("update:isoDate", this.whenMomentISO);
            }
        },
    }    
}
</script>
